<script>
  import { createEventDispatcher } from "svelte";
  import { sendVerificationEmail } from "../verification.js";
  export let user;
  const dispatch = createEventDispatcher();
  let sent = false;
  let busy = false;
  let error = "";

  async function resend() {
    busy = true;
    error = "";
    try {
      await sendVerificationEmail(user);
      sent = true;
    } catch (e) {
      error = e && e.code === "auth/too-many-requests"
        ? "Too many attempts. Please wait a few minutes and try again."
        : "Couldn't send the email. Please try again.";
    } finally {
      busy = false;
    }
  }
</script>

<div class="verify" role="status">
  <p class="verify__text">
    <strong>Confirm your email to open your window.</strong>
    We sent a link to {user.email}. Until it's confirmed, your window stays closed and nobody can see you.
  </p>
  <div class="verify__actions">
    <button type="button" class="verify__btn" on:click={() => dispatch("refresh")} disabled={busy}>I've confirmed it</button>
    <button type="button" class="verify__btn verify__btn--ghost" on:click={resend} disabled={busy || sent}>
      {sent ? "Link sent" : "Send the link again"}
    </button>
  </div>
  {#if error}<p class="verify__error">{error}</p>{/if}
</div>

<style>
  .verify {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100001;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 0.6rem 1.5rem;
    padding: 0.9rem 1.2rem;
    background: var(--cream);
    color: var(--ink);
    font: 500 1rem/1.4 Inter, system-ui, sans-serif;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
  }
  .verify__text { margin: 0; max-width: 60ch; }
  .verify__actions { display: flex; gap: 0.6rem; flex-wrap: wrap; }
  .verify__btn {
    border: 1px solid var(--ink);
    background: var(--ink);
    color: var(--cream);
    border-radius: 999px;
    padding: 0.45rem 1rem;
    font: inherit;
    cursor: pointer;
  }
  .verify__btn--ghost { background: transparent; color: var(--ink); }
  .verify__btn:disabled { opacity: 0.6; cursor: default; }
  .verify__error { margin: 0; width: 100%; text-align: center; color: var(--danger); }
</style>
